import AuxiliaryInfoItemFactory from 'bundles/payments/models/cart/auxiliaryInfoItemFactory';

class AuxiliaryInfo {
  constructor(objects: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'items' does not exist on type 'Auxiliary... Remove this comment to see the full error message
    this.items = objects.map((object) => AuxiliaryInfoItemFactory.construct(object));
  }

  getItems() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'items' does not exist on type 'Auxiliary... Remove this comment to see the full error message
    return this.items;
  }

  /**
   * Get a continue info that should be used after the payment confirmation. Note that
   * using reduce means that it'll get the first eligible continue link.
   *
   * @returns {string|null} a continueLink if one can be computed from the items in the cartInfo.
   *                          and null if a continueLink cannot be computed
   */
  getContinueInfo(cart: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'items' does not exist on type 'Auxiliary... Remove this comment to see the full error message
    return this.computeContinueInfo(this.items, cart);
  }

  /**
   * computeContinueInfo defines the strategy for computing the info for the continue link display
   * from the items.
   * @param {Array.<AuxiliaryInfoItem} items that are used to compute the link
   * @param {bundles/catalogP/models/cart} cart that provides metadata
   * @return {bundles/payments/models/cart/courseEnrollInfoItem.ContinueInfo} continueInfo
   */
  computeContinueInfo(items: $TSFixMe, cart: $TSFixMe) {
    return items.reduce(function (memo: $TSFixMe, item: $TSFixMe) {
      return memo || (item.providesContinueInfo && item.getContinueInfo(cart));
    }, null);
  }

  /**
   * Serialize to JSON to send to server
   */
  toJSON() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'items' does not exist on type 'Auxiliary... Remove this comment to see the full error message
    return this.items.map((item) => item.toJSON());
  }
}

export default AuxiliaryInfo;
